exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marginer[data-v-0666864a]{margin:30px}.row-items[data-v-0666864a]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.separator[data-v-0666864a]{border-left:1px solid #000;margin-top:30px;height:500px;width:1px}.btn-cta[data-v-0666864a]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:1px solid #000;padding:10px 30px;font-size:18px;outline:none;-webkit-box-shadow:none;box-shadow:none}.fuller[data-v-0666864a]{width:calc(100% - 2px);height:calc(100% - 2px);padding:1px}", ""]);

// exports
